function initNavbarSearch() {
  var toggle = document.getElementById("navbar-search-toggle");
  var input = document.getElementById("navbar-search-input");
  var close = document.getElementById("navbar-search-close");
  var form = document.getElementById("navbar-search-form");
  var spinner = document.getElementById("navbar-search-spinner");

  if (!toggle || !input || !close || !form) return;

  if (toggle._searchBound) return;
  toggle._searchBound = true;

  var parentLi = toggle.closest(".nav-item");

  parentLi.addEventListener("shown.bs.dropdown", function() {
    setTimeout(function() { input.focus(); }, 50);
  });

  parentLi.addEventListener("hidden.bs.dropdown", function() {
    input.value = "";
  });

  close.addEventListener("click", function() {
    var dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle);
    dropdown.hide();
  });

  form.addEventListener("submit", function(e) {
    if (input.value.trim().length < 2) return;
    if (!spinner) return;
    var icon = form.querySelector(".navbar-search-input-icon .fa-search");
    if (icon) icon.classList.add("d-none");
    spinner.classList.remove("d-none");
    input.readOnly = true;
  });
}

document.addEventListener("turbo:load", initNavbarSearch);
document.addEventListener("DOMContentLoaded", initNavbarSearch);
